import type { IHttpGetConfig } from '../httpClient.model';

export default (config: IHttpGetConfig): IHttpGetConfig => {
  const params = config.params;
  if (!params) {
    return config;
  }

  const queryParams = Object.keys(params)
    .filter(key => params[key] !== undefined)
    .map(key => `${key}=${encodeURI(params[key])}`)
    .join('&');

  const updatedConfig = {
    ...config,
    url: queryParams.length ? `${config.url}?${queryParams}` : config.url,
  };

  return updatedConfig;
};
